import { render, staticRenderFns } from "./OTPCode.vue?vue&type=template&id=1f624e00&"
import script from "./OTPCode.vue?vue&type=script&lang=js&"
export * from "./OTPCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports